import { useState, useEffect } from 'react';
import { FaRegStar, FaStar } from 'react-icons/fa';
import { AutoSizer, Column, SortDirection, Table } from "react-virtualized";
import { Col, Row, Card } from "reactstrap";
import { Theme } from '../../../config/constants';
import moment from 'moment';
import { Tooltip } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { sortableHeaderRenderer } from "../../../sharedComponents/Tables/SortableHeaderRenderer";

const ReportListWidget = ({ reports }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [reportData, setReportData] = useState(reports);
    const [sortBy, setSortBy] = useState('');
    const [sortDirection, setSortDirection] = useState(null);

    const onClickReport = (report) => {
        navigate(location.pathname + '/details/' + report.id);
    };

    useEffect(() => {
        if (reports) {
            setReportData(reports);
        }
    }, [reports]);

    const sortedReportTableData = (() => {
        if (!reportData) return [];
        const sorted = [...reportData];
        switch (sortBy) {
            case 'name' : {
                sorted.sort((a, b) => {
                    if (sortDirection === SortDirection.ASC) {
                        return (a.name.localeCompare(b.name));
                    } else {
                        return (b.name.localeCompare(a.name));
                    }
                });
                break;
            }
            case 'createdAt' : {
                sorted.sort((a, b) => {
                    if (sortDirection === SortDirection.ASC) {
                        return moment(a.createdAt).diff(moment(b.createdAt));
                    } else {
                        return moment(b.createdAt).diff(moment(a.createdAt));
                    }
                });
                break;
            }
            case 'lastViewed' : {
                sorted.sort((a, b) => {
                    if (sortDirection === SortDirection.ASC) {
                        return moment(a.lastViewed).diff(moment(b.lastViewed));
                    } else {
                        return moment(b.lastViewed).diff(moment(a.lastViewed));
                    }
                });
                break;
            }
            default: {
                // Do nothing
            }
        }
        return sorted;
    })();

    return (
        <Card>
            <Row style={{ height: 'calc(100vh - 170px)' }}>
                <Col style={{overflowY: 'auto', height: '100%'}}>
                    <AutoSizer>
                        {({ width, height}) => (
                            <Table className="table reportsListTable border-grayLight"
                                width={width}
                                height={height}
                                headerHeight={34.5}
                                rowHeight={38}
                                rowCount={sortedReportTableData?.length}
                                rowGetter={({ index }) => sortedReportTableData?.[index]}
                                onRowClick={({ rowData }) => {onClickReport(rowData);}}
                                sort={({ sortBy: sb, sortDirection: sd }) => {
                                   setSortBy(sb);
                                   setSortDirection(sd);
                                }}
                                sortBy={sortBy}
                                sortDirection={sortDirection}
                            >
                                <Column
                                    label=""
                                    dataKey="favourite"
                                    width={30}
                                    cellRenderer={({ cellData }) => (
                                        <div>
                                            {cellData ? (
                                                <FaStar size={'20px'} color={Theme().colors.accent} />
                                            ) : (
                                                <FaRegStar size={'20px'} color={'black'} />
                                            )}
                                        </div>
                                    )}
                                />
                                <Column
                                    label="Report Name"
                                    dataKey="name"
                                    width={width * 0.5}
                                    headerRenderer={sortableHeaderRenderer}
                                    cellRenderer={({rowData, cellData}) =>
                                    rowData.ownerId ?
                                    <span>{cellData}</span>
                                    :  <Tooltip title={"This is a system created report. To make permanent filter changes to this report, please create a copy."} placement="right">
                                            <span style={{fontWeight: 'bold'}}>{cellData}</span>
                                        </Tooltip>
                                    }
                                />
                                <Column
                                    label="Date Created"
                                    dataKey="createdAt"
                                    width={width * 0.5}
                                    headerRenderer={sortableHeaderRenderer}
                                    cellRenderer={({cellData}) =>
                                    <span>{moment(cellData).format('MMMM Do YYYY, h:mma')}</span>
                                    }
                                />
                                <Column
                                    label="Last Viewed"
                                    dataKey="lastViewed"
                                    width={width * 0.5}
                                    headerRenderer={sortableHeaderRenderer}
                                    cellRenderer={({cellData}) =>
                                    <span>{moment(cellData).format('MMMM Do YYYY, h:mma')}</span>
                                    }
                                />
                            </Table>
                        )}

                    </AutoSizer>
                </Col>
            </Row>
        </Card>
    )
}

export default ReportListWidget;
